import styled, { css } from "styled-components";
import { modalSizes } from "./modalSizes";
export const positionStyles = {
    center: ["center", "center"],
    top: ["flex-start", "center"],
    "top-right": ["flex-start", "flex-end"],
    right: ["center", "flex-end"],
    "bottom-right": ["flex-end", "flex-end"],
    bottom: ["flex-end", "center"],
    "bottom-left": ["flex-end", "flex-start"],
    left: ["center", "flex-start"],
    "top-left": ["flex-start", "flex-start"],
};
export const ModalContent = styled.div `
  z-index: 100;
  flex-grow: 1;
  display: flex;
  max-height: 100%;
  transition: all 300ms ease;

  ${(p) => p.$fullSize
    ? `
          width: 100%;
          height: 100%;
        `
    : p.$maxWidth
        ? css `
            max-width: ${p.$maxWidth};
          `
        : p.$size
            ? modalSizes[p.$size]
            : ""}

  ${(p) => positionStyles[p.$position || "center"]};
`;
const fadeAnimation = css `
  &.fade-enter {
    opacity: 0;
  }

  &.fade-enter-active {
    opacity: 1;
    transition: opacity 300ms;
  }

  &.fade-enter-done {
    opacity: 1;
  }

  &.fade-exit {
    opacity: 1;
  }

  &.fade-exit-active {
    opacity: 0;
    transition: opacity 0ms;
  }

  &.fade-exit-done {
    display: none;
    opacity: 0;
  }
`;
const slideRightAnimation = css `
  &.slideRight-enter {
    opacity: 0;

    ${ModalContent} {
      transform: translateX(100%);
    }
  }

  &.slideRight-enter-active {
    opacity: 1;

    ${ModalContent} {
      transform: translateX(0);
    }
  }

  &.slideRight-exit {
    opacity: 1;

    ${ModalContent} {
      transform: translateX(0);
    }
  }

  &.slideRight-exit-done {
    display: none;
  }

  &.slideRight-exit-active {
    opacity: 0;

    ${ModalContent} {
      transform: translateX(100%);
    }
  }
`;
const slideLeftAnimation = css `
  &.slideLeft-enter {
    opacity: 0;

    ${ModalContent} {
      transform: translateX(-100%);
    }
  }

  &.slideLeft-enter-active {
    opacity: 1;

    ${ModalContent} {
      transform: translateX(0);
    }
  }

  &.slideLeft-exit {
    opacity: 1;

    ${ModalContent} {
      transform: translateX(0);
    }
  }

  &.slideLeft-exit-done {
    display: none;
  }

  &.slideLeft-exit-active {
    opacity: 0;

    ${ModalContent} {
      transform: translateX(-100%);
    }
  }
`;
const slideBottomAnimation = css `
  &.slideBottom-enter {
    opacity: 0;

    ${ModalContent} {
      transform: translateY(100%);
    }
  }

  &.slideBottom-enter-active {
    opacity: 1;

    ${ModalContent} {
      transform: translateY(0);
    }
  }

  &.slideBottom-exit {
    opacity: 1;

    ${ModalContent} {
      transform: translateY(0);
    }
  }

  &.slideBottom-exit-done {
    display: none;
  }

  &.slideBottom-exit-active {
    opacity: 0;

    ${ModalContent} {
      transform: translateY(100%);
    }
  }
`;
export const animationStyles = {
    fade: fadeAnimation,
    slideRight: slideRightAnimation,
    slideLeft: slideLeftAnimation,
    slideBottom: slideBottomAnimation,
};
